module.exports = __webpack_public_path__ + "img/sup_login_6.20a62c9a.png";